import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AgentOnboardingAudience, type AgentOnboardingWalkthroughStep } from './agentOnboardingAnalytics';
import META from './useTrackAgentOnboardingSkipped.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type { AgentOnboardingWalkthroughStep } from './agentOnboardingAnalytics';

export type UseTrackAgentOnboardingSkippedParams = {
  audience: AgentOnboardingAudience;
  step: AgentOnboardingWalkthroughStep;
};

export const useTrackAgentOnboardingSkipped = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentOnboardingSkipped = useCallback(
    (params: UseTrackAgentOnboardingSkippedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentOnboardingSkipped };
};
